import { Cover, Stack } from 'design-system'

import { BlockedUserCardWrapper } from './blocked-user-card-wrapper'

export const BlockedUserError = () => {
  return (
    <Cover fullSize className="px-4">
      <BlockedUserCardWrapper>
        <Stack gap={4}>
          <h2 className="text-center text-base">
            Your Access to This Community is Restricted
          </h2>
          <div>
            Ooops... We can&apos;t load additional information. Please refresh
            this page, or contact support{' '}
            <a href="mailto:support@yellowdig.com">support@yellowdig.com</a>
          </div>
        </Stack>
      </BlockedUserCardWrapper>
    </Cover>
  )
}
